import { LegalPage } from "../components/LegalPage";
import { useSeo } from "../lib/useSeo";

export default function Privacy() {
  useSeo({
    title: "Privacy | SimplyRefer",
    description: "Privacy information for SimplyRefer users, GP practices, clinicians and clinics in Australia.",
    canonicalPath: "/privacy",
  });
  return (
    <LegalPage title="Privacy Policy" updated="June 2026" testId="privacy-page">
      <p>
        SimplyRefer ("we", "us") is committed to protecting your privacy and handling personal information in accordance
        with the Australian Privacy Act 1988 (Cth) and the Australian Privacy Principles (APPs). This policy explains
        what we collect, why, and how we protect it.
      </p>

      <h2>1. Information we collect</h2>
      <ul>
        <li><strong>Account information:</strong> name, email, clinic name, suburb, and role (GP, clinician, or clinic manager).</li>
        <li><strong>Clinician details:</strong> profession, specialty, location, AHPRA registration number, and availability.</li>
        <li><strong>Referral activity:</strong> the clinician selected, referring GP practice, referral option used and any optional SimplyRefer Reference created. No patient health information is collected.</li>
        <li><strong>Billing information:</strong> handled securely by our payment processor (Stripe); we do not store full card details.</li>
      </ul>

      <h2>2. How we use information</h2>
      <ul>
        <li>To operate the directory, verify AHPRA registration, and facilitate referrals.</li>
        <li>To manage subscriptions, free trials, and billing.</li>
        <li>To send service notifications (e.g. referral updates) and respond to support requests.</li>
        <li>To maintain security and improve the Service.</li>
      </ul>

      <h2>3. Disclosure</h2>
      <p>
        Referral and clinician directory information is shared with the relevant participating professionals to deliver
        the Service. We use trusted third-party providers (such as Supabase for hosting/database, Stripe for payments,
        and an email provider for notifications). We do not sell your personal information.
      </p>

      <h2>4. Data security</h2>
      <p>
        We use access controls, row-level security, and encryption in transit (HTTPS) to protect your data. Access to
        administrative functions is restricted to authorised SimplyRefer staff. No method of transmission or storage is
        completely secure, but we take reasonable steps to safeguard your information.
      </p>

      <h2>5. Patient information</h2>
      <p>
        SimplyRefer is designed so that no patient health information is required or stored. We record the referring GP
        practice, clinician selected, referral option used and any optional SimplyRefer Reference, never patient details.
        Any clinical information you share directly with another practitioner outside SimplyRefer must be handled in
        accordance with applicable health records and privacy laws, with appropriate patient consent.
      </p>

      <h2>6. Access, correction & retention</h2>
      <p>
        You may access or correct your account information at any time. We retain information for as long as needed to
        provide the Service and meet legal obligations. You can request deletion by contacting us.
      </p>

      <h2>7. Contact</h2>
      <p>
        For privacy enquiries or to make a complaint, contact our team at hello@simplyrefer.com.au. If you are not
        satisfied with our response, you may contact the Office of the Australian Information Commissioner (OAIC).
      </p>
    </LegalPage>
  );
}
